"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMessagesToGeneralSaga = fetchMessagesToGeneralSaga;
exports.fetchMessagesSaga = fetchMessagesSaga;
exports.fetchCountNotificationsSaga = fetchCountNotificationsSaga;
exports.setReadMessageSaga = setReadMessageSaga;
exports.setReadMessagesSaga = setReadMessagesSaga;
exports.messagesProviderSaga = messagesProviderSaga;
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../LanguagesProvider/selectors");
const errors_1 = require("../../utils/errors");
const slice_1 = require("../AccountProvider/slice");
const api_1 = require("../../api/messages/api");
const slice_2 = require("./slice");
function* fetchMessagesToGeneralSaga(action) {
    const { reqFetchParams, layoutType } = action.payload;
    try {
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const { data } = yield (0, effects_1.call)(api_1.getMessageList, {
            ...reqFetchParams,
            locale,
        });
        yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchMessagesToGeneralSuccess({
            ...data,
            layoutType: action.payload.layoutType,
        }));
        yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchMessageSuccess({
            resData: data,
            layoutType,
        }));
    }
    catch (e) {
        console.error('Error occurred while fetching messages', e);
        const errorData = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchMessagesToGeneralError(errorData));
        yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchMessageError({
            errorData,
            layoutType,
        }));
    }
}
function* fetchMessagesSaga(action) {
    yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchMessagesToGeneral({
        reqFetchParams: action.payload.req,
        layoutType: action.payload.layoutType,
    }));
}
function* fetchCountNotificationsSaga() {
    try {
        const { data } = yield (0, effects_1.call)(api_1.getMessageCount);
        yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchCountNotificationsSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching message', error);
        yield (0, effects_1.put)(slice_2.messagesProviderActions.fetchCountNotificationsError(error));
    }
}
function* setReadMessageSaga(action) {
    try {
        yield (0, effects_1.call)(api_1.markAsRead, {
            ...action.payload,
        });
        yield (0, effects_1.put)(slice_2.messagesProviderActions.setReadMessageSuccess());
    }
    catch (e) {
        const errorData = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching message', errorData);
        yield (0, effects_1.put)(slice_2.messagesProviderActions.setReadMessageError({
            errorData,
            messageId: action.payload.messageId,
        }));
    }
}
function* setReadMessagesSaga() {
    try {
        yield (0, effects_1.call)(api_1.readAllMessages);
        yield (0, effects_1.put)(slice_2.messagesProviderActions.setReadMessagesSuccess());
    }
    catch (e) {
        const errorData = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching messages', errorData);
        yield (0, effects_1.put)(slice_2.messagesProviderActions.setReadMessagesError({
            errorData,
        }));
    }
}
function* messagesProviderSaga() {
    yield (0, effects_1.all)([
        yield (0, effects_1.takeLatest)(slice_2.messagesProviderActions.fetchMessagesToGeneral.type, fetchMessagesToGeneralSaga),
        yield (0, effects_1.takeLatest)(slice_2.messagesProviderActions.fetchMessages.type, fetchMessagesSaga),
        yield (0, effects_1.takeLatest)(slice_2.messagesProviderActions.fetchCountNotifications.type, fetchCountNotificationsSaga),
        yield (0, effects_1.takeLatest)(slice_2.messagesProviderActions.setReadMessage.type, setReadMessageSaga),
        yield (0, effects_1.takeLatest)(slice_2.messagesProviderActions.setReadMessages.type, setReadMessagesSaga),
        yield (0, effects_1.takeLatest)(slice_1.accountProviderActions.getUserSuccess.type, fetchCountNotificationsSaga),
    ]);
}
//# sourceMappingURL=saga.js.map